import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../config/msalConfig";
import { fetchUsers } from "../api/api";
import Login from "./Login";

const LoginM = () => {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [email, setEmail] = useState("");

  const handleMicrosoftLogin = () => {
    instance.loginRedirect(loginRequest).catch((e) => {
      console.error("Login redirect error:", e);
    });
  };

  const handlePostLogin = async () => {
    const account = accounts[0];
    if (!account) return;

    const emailToUse = account.username || email;

    try {
      const userData = await fetchUsers(emailToUse);
      if (!userData) {
        setError("User not found.");
        return;
      }

      if (userData.role === "Member") {
        switch (userData.team_id) {
          case "A":
            navigate("/teamA");
            break;
          case "B":
            navigate("/teamB");
            break;
          case "C":
            navigate("/teamC");
            break;
          default:
            setError("Invalid team ID for Member.");
        }
      } else if (userData.role === "Leader") {
        userData.team_id === "D" ? navigate("/teamD") : navigate("/teamlead");
      } else {
        setError("Unknown role.");
      }
    } catch (err) {
      console.error("Error fetching user:", err);
      setError("Failed to fetch user details.");
    }
  };

  if (accounts.length > 0) {
    handlePostLogin(); // Process only after loginRedirect
    return <div>User not authorised</div>;
  }

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <div className="card p-4" style={{ width: "20rem" }}>
        <div className="text-center">
          <img src="/growindigologo.png" alt="Logo" className="img-fluid" />
        </div>
        <h3 className="text-center mb-4" style={{ color: "#1DA5B1" }}>
          QC Login
        </h3>

        {/* <input
          type="email"
          className="form-control mb-3"
          placeholder="Enter Microsoft Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {error && <div className="text-danger mb-2">{error}</div>} */}

        <button
          type="button"
          className="btn flex items-center border-2 px-4 py-2 rounded transition-all group"
          style={{
            backgroundColor: "#fef2f2",
            color: "#fca5a5",
            borderColor: "#fca5a5",
            borderWidth: "2px",
            fontWeight: "500",
          }}
          onClick={handleMicrosoftLogin}
        >
          <span className="vertical-center">
            <img
              src="/Microsoft_logo.svg.png"
              alt="Logo"
              className="item-centered img-fluid"
              style={{ maxWidth: "20px" }}
            />
          </span>
          {"   "}Continue with Microsoft
        </button>

        <Login />
      </div>
    </div>
  );
};

export default LoginM;
